import { useQuery } from "@tanstack/react-query";
import { useProperty } from "../../../../components/property-provider";
import { useAuthorizationService } from "../../../../lib/auth.service";
import { occupationsQueryKeys } from "../../infrastructure/cache/OccupationsCacheStrategy";
import { getAllOccupations } from "../../infrastructure/occupation.api";

export function useOccupationsQuery(propertyTicker: string, enabled = true) {
  const property = useProperty();
  const authService = useAuthorizationService();

  return useQuery({
    queryKey: occupationsQueryKeys.list(propertyTicker),
    queryFn: async () => {
      const token =
        propertyTicker === property.ticker
          ? property.token
          : await authService.getRptToken(propertyTicker);
      return getAllOccupations(propertyTicker, token);
    },
    enabled: enabled && !!propertyTicker,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
